/**
 * The mark beside the bench's title: the bench itself, small.
 *
 * It was a line-drawn molecule first, and it was wrong twice over — thin
 * enough at title size to read as a smudge, and monochrome beside a bench
 * whose whole subject is colour. A flask of blue is the picture this app is
 * already made of. It stood over a flame once, and the flame took the bottom
 * fifth of the box to say something the bubbles already say; without it the
 * flask is drawn at the box's full height.
 *
 * Its own colours, not `currentColor`: they are the bench's own liquid blue
 * and glass, so the mark and the thing it stands for agree in either theme.
 */
export function BenchMark({ size = 26, className }: { size?: number; className?: string }): React.JSX.Element {
  const flask = 'M10.3 3 L10.3 8.2 L5.1 16.6 A1.6 1.6 0 0 0 6.4 18.4 '
    + 'L17.6 18.4 A1.6 1.6 0 0 0 18.9 16.6 L13.7 8.2 L13.7 3 Z';
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <defs>
        {/* The liquid is a straight band, cut to the flask — which is what
            gives it the cone's own slope for nothing. */}
        <clipPath id="chemlab-mark-glass"><path d={flask} /></clipPath>
      </defs>
      {/* Drawn on the old 2-18.4 grid and stretched to fill 1-23; the stroke
          is thinned by the same factor so the glass keeps its weight. */}
      <g transform="translate(12 1) scale(1.34) translate(-12 -2)">
        <path d={flask} fill="#cfe0f0" fillOpacity="0.34" stroke="#9fb4c8" strokeWidth="0.82" strokeLinejoin="round" />
        <g clipPath="url(#chemlab-mark-glass)">
          <rect x="3" y="13.4" width="18" height="6" fill="#3b9ae1" />
          <rect x="3" y="13.4" width="18" height="0.9" fill="#7cc4f2" />
          {/* two bubbles, which is what says the liquid is doing something */}
          <circle cx="10.4" cy="16.4" r="0.8" fill="#eaf6ff" opacity="0.8" />
          <circle cx="13.5" cy="15.4" r="0.55" fill="#eaf6ff" opacity="0.7" />
        </g>
        {/* the ground-glass collar every flask on this bench is drawn with */}
        <rect x="9.7" y="2" width="4.6" height="1.7" rx="0.8" fill="#9fb4c8" />
      </g>
    </svg>
  );
}
